<template>
  <div class="chatbot">
    <transition name="van-fade">
      <div
        id="chatbot"
        v-show="showChatbot"
        :style="chatbotStyle"
        :class="chatbotClass">
        <iframe :src="chatbotIframeSrc" frameborder="0"></iframe>
      </div>
    </transition>
    <transition name="van-fade">
      <div
        id="chatbotNudge"
        class="display-block chatbot-nudge"
        v-show="showNudge"
        :style="nudgeStyle"
        @click="onNudgeClick">
        <p v-html="nudgeData.text"></p>
        <transition name="van-fade" v-for="(option, key) in nudgeData.options" :key="key">
          <div
            class="message message-option watson-font"
            v-show="showMessageOption[key]"
            @click="onMessageOptionClick(key)">{{ option.label }}</div>
        </transition>
        <div class="close-btn-nudge" @click="handleCloseNudge">
          <i class="close-btn-icon iconfont icona-xingzhuangbeifen81"></i>
        </div>
      </div>
    </transition>
    <transition name="van-fade">
      <div
        id="btnDialogToggle"
        v-show="showToggle"
        :style="toggleStyle"
        @click="onToggleClick"></div>
    </transition>
    <transition name="van-fade">
      <div
        id="btnDialogClose-div"
        v-if="showCloseDiv || showCloseToDialog"
        :class="[showCloseToDialog && 'close-dialog-btn']"
        @click="onCloseDivClick">
        <transition name="van-fade">
          <div id="btnDialogClose" class="display-block el-icon-close" :style="dialogCloseBtnStyle"></div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { ROOT_COMPANY_ID } from '@/constant/company'
import { CHAT_BOT_DOAMIN_MAP } from '@/constant/chatbot'
import { getTextColorByBgColor, deviceType } from '@/utils/common'

const referralWorld = '我想要推荐朋友'
const actionTypes = {
  close: { key: 'close', text: 'close' },
  web: { key: 'webUrl', text: 'http' },
  referral: { key: 'referral', text: referralWorld },
  prescreen: { key: 'prescreen' },
  postback: { key: 'postback' }
}

export default {
  props: {
    hasReferralIcon: {
      type: Boolean,
      default: null
    },
    showReferral: {
      type: Boolean,
      default: null
    },
    generateUserId: {
      required: true
    },
    showChatbotMessageBox: {
      type: Boolean,
      default: null
    },
    company: {
      type: Object,
      required: true
    },
    jobId: {
      type: String,
      default: ''
    },
    context: {
      type: Object,
      default: () => {
        return {}
      }
    },
    deferTriggers: {
      type: Boolean,
      default: false
    },
    henkelWechatAccountOpenId: {
      type: String,
      default: ''
    },
    btnDialogToggleBootem: {
      type: String,
      default: ''
    },
    btnDialogToggleRight: {
      type: String,
      default: ''
    },
    enableCloseBtnToDialog: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
    nudgeBottom: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      CHAT_BOT_DOAMIN_MAP,
      chatbotIframeSrc: null,
      chatbotClass: null,
      showChatbot: false,
      showNudge: false,
      showToggle: false,
      showCloseDiv: false,
      showCloseToDialog: false,
      showCloseBtn: false,
      openChatWindow: false,
      showMessageOption: {},
      chatbotStyle: null,
      toggleStyle: {},
      nudgeStyle: null,
      nudgeData: [],
      scrollTop: 0,
      bodyClass: 'model-open',
      dialogCloseBtnStyle: {}
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount']),
    rootCompanyId () {
      return this.company.root_company ? this.company.root_company.id : this.company.id
    },
    isHenkelCompany () {
      return this.rootCompanyId === ROOT_COMPANY_ID.HENKEL
    },
    isHsbcCompany () {
      return this.rootCompanyId === ROOT_COMPANY_ID.HSBC
    },
    isDiageoCompany () {
      return this.rootCompanyId === ROOT_COMPANY_ID.DIAGEO
    },
    chatbotBasePath () {
      // if (process.env.VUE_APP_USE_VUE_CHATBOT_PAGE === 'true') {
      //   return `${process.env.VUE_APP_VUE_CHATBOT_PAGE_DOMAIN}/chatbot-vue/${this.rootCompanyId}`
      // }
      return `${location.origin}/chatbot-vue/${this.rootCompanyId}`
    },
    isPc () {
      return deviceType.isPc
    }
  },
  created () {
    window.onmessage = this.receiveMessage
    window.onresize = this.onWindowResize
    window.onunload = this.onUnloadEvent
    this.init()
  },
  mounted () {
    if (this.jobId && !this.deferTriggers) {
      this.stay30sInJobDetailPage()
    }
  },
  methods: {
    ...mapGetters('account', ['getUserUUID']),
    ...mapActions('account', ['getSessionAccountInfo']),
    ...mapActions('chatbot', ['chatbotWelcome', 'chatbotWelcomeBack', 'chatbotStayJobDetail', 'chatbotClickApplyJobButton', 'chatbotOperationChatWindow']),
    async init () {
      this.showToggle = true
      this.onWindowResize()
      if (this.showReferral) {
        this.toggleStyle = {
          bottom: '150px'
        }
        if (!this.isPc) {
          this.nudgeStyle = 'bottom: 244px;'
        }
      } else if (!this.showReferral) {
        if (this.hasReferralIcon) {
          this.toggleStyle = {
            bottom: '230px'
          }
          if (!this.isPc) {
            this.nudgeStyle = 'bottom: 321px;'
          }
        } else if (!this.hasReferralIcon) {
          this.toggleStyle = {
            bottom: '100px'
          }
          if (!this.isPc) {
            this.nudgeStyle = 'bottom: 195px;'
          }
        }
      }
      if (this.nudgeBottom) {
        this.nudgeStyle = `bottom: ${this.nudgeBottom}`
      }

      if (this.btnDialogToggleBootem) {
        this.toggleStyle = {
          bottom: this.btnDialogToggleBootem
        }
      }

      if (this.btnDialogToggleRight) {
        this.toggleStyle.right = this.btnDialogToggleRight
      }

      if (this.deferTriggers) {
        return
      }

      const hasVisitJobDetailPage = false
      let userId = ''
      if (this.isHenkelCompany) {
        userId = this.getCookie('user_id')
      } else if (this.isHsbcCompany) {
        userId = this.getCookie('hsbc_user_id')
      } else if (this.isDiageoCompany) {
        userId = this.getCookie('diageo_user_id')
      } else {
        userId = this.getCookie(`user_id_${this.rootCompanyId}`)
      }

      if (userId === '' || typeof (userId) === 'undefined') {
        this.welcomeTrigger(this.jobId, this.rootCompanyId)
      } else if (!hasVisitJobDetailPage) {
        this.welcomeBackTrigger()
      }
      const jobId = this.jobId
      let accountId = ''
      if (this.getCurrentAccount && this.getCurrentAccount.id) {
        accountId = this.getCurrentAccount && this.getCurrentAccount.id
      }
      const context = this.context || {}
      const userUuid = this.getUserUUID()(this.rootCompanyId)
      const resetSessionId = this.getSavedChatbotSessionId()
      let payload = {
        client: 'mobile',
        jobId,
        accountId,
        user_uuid: userUuid,
        resetSessionId
      }
      if (!(resetSessionId && context.type === 'GET_QUESTIONNAIRE')) {
        payload = { ...payload, ...context }
      }
      const pl = payload && encodeURIComponent(JSON.stringify(payload))
      this.chatbotIframeSrc = `${this.chatbotBasePath}/?pl=${pl}`
      if (this.showChatbotMessageBox) {
        this.showChatbot = true
      }
    },
    getSavedChatbotSessionId () {
      const jobId = this.jobId
      if (!jobId) {
        return
      }
      const timedData = JSON.parse(localStorage.getItem('chatbot_timed') || '{}')
      const jobData = timedData[jobId]
      const createdTime = jobData?.createdTime
      if (!jobData || !createdTime) {
        return
      }
      const expiredTime = moment().subtract(5, 'minutes').valueOf()
      if (createdTime > expiredTime) {
        return jobData.sessionId
      }
    },
    saveChatbotSessionId (sessionId) {
      const jobId = this.jobId
      if (!jobId) {
        return
      }
      const timedData = JSON.parse(localStorage.getItem('chatbot_timed') || '{}')
      timedData[jobId] = {
        createdTime: moment().valueOf(),
        sessionId
      }
      localStorage.setItem('chatbot_timed', JSON.stringify(timedData))
    },
    welcomeTrigger (jobID, companyID) {
      const params = { companyId: companyID }
      if (jobID) {
        params.jobID = jobID
      }
      if (this.henkelWechatAccountOpenId) {
        params.openID = this.henkelWechatAccountOpenId
      }
      this.chatbotWelcome(params).then(res => {
        if (res.has_visit_job_detail_page) {
          this.hasVisitJobDetailPage = true
        }
        this.triggerChatbot('return_welcome', true, null)
        if (!this.hasVisitJobDetailPage) {
          this.welcomeBackTrigger()
        }
      })
    },
    welcomeBackTrigger () {
      const jobId = this.jobId
      if (jobId) {
        this.chatbotWelcomeBack(this.jobId).then(res => {
          if (res.data.multiple_visit_job_detail_page) {
            const payload = { url: window.location.origin }
            this.triggerChatbot('return_jd', true, payload)
          }
        })
      }
    },
    async stay30sInJobDetailPage () {
      const jobID = this.jobId
      setTimeout(() => {
        this.chatbotStayJobDetail(jobID).then(res => {
          if (res.status === 'success') {
            const payload = {
              url: window.location.origin
            }
            if (!this.showChatbot) {
              this.triggerChatbot('nudge', true, payload)
            }
          }
        })
      }, 30000)
    },
    receiveMessage ($event) {
      if (this.chatbotBasePath.startsWith($event.origin)) {
        const msg = $event.data
        switch (msg) {
          case 'scrollTop':
            window.scrollTo(0, 0)
            break
          default:
            if (typeof msg === 'object') {
              if (msg._chatbotInfo) {
                const chatbotInfo = msg._chatbotInfo
                this.$set(this.toggleStyle, 'backgroundImage', `url(${chatbotInfo.avatarUrl})`)
                document.body.style.setProperty('--chatbot-color', chatbotInfo.mainColor)
                this.$set(this.dialogCloseBtnStyle, 'color', getTextColorByBgColor(chatbotInfo.mainColor))
              }
              if (msg._set_session_id) {
                this.saveChatbotSessionId(msg._set_session_id)
              }
              this.nudgeChatbot(msg)
            }
            break
        }
      }
    },
    nudgeChatbot (data) {
      if (!data || !data.length || data.length < 1) {
        return
      }
      const firstData = data[0]
      const secondData = data[1]
      const nudgeData = { text: data[0].text, options: {} }
      if (firstData.response_type === 'text' && firstData.text === 'is_prescreening') {
        const prescreen = JSON.parse(secondData.text)
        nudgeData.text = prescreen.question_title
        _.forEach(prescreen.question_options, (question, key) => {
          nudgeData.options[key] = {
            action: actionTypes.prescreen.key,
            label: question.option,
            value: question.value
          }
          this.showMessageOption[key] = true
        })
      } else if (secondData?.response_type === 'option') {
        const options = secondData.options
        for (const key in options) {
          const option = options[key]
          let action = null
          let url = null
          if (option.value.input.text === actionTypes.close.text) {
            action = actionTypes.close.key
          } else if (option.value.input.text.indexOf('http') === 0) {
            action = actionTypes.web.key
            url = option.value.input.text
          } else if (option.value.input.text === actionTypes.referral.text) {
            action = actionTypes.referral.key
          } else {
            action = actionTypes.postback.key
          }
          nudgeData.options[key] = {
            action: action,
            url: url,
            label: option.label
          }
          this.showMessageOption[key] = true
        }
      }
      this.showNudgeContent = true
      this.nudgeData = nudgeData
      if (!this.showNudge) {
        this.showNudge = true
      }
    },
    handleCloseNudge () {
      this.showNudge = false
    },
    doBeforeOpenModal () {
      if (window.innerWidth < 480) {
        this.showCloseDiv = true
        this.showCloseBtn = true

        this.chatbotClass = 'model-open'
        document.querySelector('#main').style.overflow = 'hidden'
        document.body.style.overflow = 'hidden'
        this.afterOpen()
      } else if (this.enableCloseBtnToDialog) {
        this.showCloseToDialog = true
      }
    },
    triggerChatbot (text, popup = false, payload = null) {
      const context = this.context || {}
      if (context.type === 'GET_QUESTIONNAIRE' && text !== 'prescreen') {
        return
      }
      this.showNudge = false
      const pu = popup ? '1' : '0'
      const jobId = this.jobId
      let accountId = ''
      if (this.getCurrentAccount && this.getCurrentAccount.id) {
        accountId = this.getCurrentAccount && this.getCurrentAccount.id
      }
      const userUuid = this.getUserUUID()(this.rootCompanyId)
      const payloadTemp = {
        client: 'mobile',
        jobId,
        accountId,
        user_uuid: userUuid,
        ...context,
        ...payload
      }
      const pl = encodeURIComponent(JSON.stringify(payloadTemp))
      this.chatbotIframeSrc = `${this.chatbotBasePath}/?t=${text}&pu=${pu}&pl=${pl}`
      if (!popup) {
        if (!this.showChatbot) {
          this.showChatbot = true
        }
      }
    },
    displayReferralPop () {
      if (this.showReferral) {
        this.toggleStyle.zIndex = 0
        this.$emit('referralSubmitInfoShow')
      } else {
        this.triggerChatbot(referralWorld, false, null)
        this.doBeforeOpenModal()
      }
    },
    onWindowResize () {
      if (window.innerWidth < 480) {
        this.chatbotStyle = 'width: 100%; height: 100%; max-height: 100vh;'
        if (this.showChatbot) {
          this.showCloseDiv = true
          this.showCloseBtn = true
        } else {
          this.showCloseDiv = false
          this.showCloseBtn = false
          this.showCloseToDialog = false
        }
      } else {
        this.chatbotStyle = 'width: 360px; height: 480px'
        this.showCloseDiv = false
        this.showCloseBtn = false
      }
    },
    onMessageOptionClick (key) {
      const option = this.nudgeData.options[key]
      const action = option.action
      switch (action) {
        case actionTypes.close.key:
          this.showMessageOption[key] = false
          break
        case actionTypes.web.key:
          this.doBeforeApplyJob()
          break
        case actionTypes.referral.key:
          this.displayReferralPop()
          break
        case actionTypes.prescreen.key:
          this.triggerChatbot(action, false, {
            autoSendText: option.label,
            autoSendActualValueText: option.value || option.label,
            showAutoSendText: true
          })
          this.doBeforeOpenModal()
          break
        default:
          this.triggerChatbot(option.label, false, null)
          this.doBeforeOpenModal()
          break
      }
    },
    doBeforeApplyJob () {
      const jobID = this.jobId
      this.chatbotClickApplyJobButton(jobID)
      this.$emit('applyJob')
    },
    onNudgeClick () {
      this.showNudge = false
    },
    onToggleClick () {
      if (!this.clickable) {
        return
      }
      this.showNudge = false
      if (this.showChatbot) {
        this.showChatbot = false
        this.showCloseToDialog = false
        if (!this.isPc) {
          document.querySelector('#main').style.overflow = 'visible'
          document.body.style.overflow = 'visible'
        }
        this.openChatWindow = false
        this.chatbotOperationChatWindow({ companyId: this.rootCompanyId, open: false })
        if (window.innerWidth < 480) {
          this.showCloseDiv = false
          this.showCloseBtn = false
          this.chatbotClass = 'model-open'
          this.afterOpen()
        }
      } else {
        this.showChatbot = true
        if (!this.isPc) {
          document.querySelector('#main').style.overflow = 'hidden'
          document.body.style.overflow = 'hidden'
        }
        this.openChatWindow = true
        this.chatbotOperationChatWindow({ companyId: this.rootCompanyId, open: true })
        if (window.innerWidth < 480) {
          this.showCloseDiv = true
          this.showCloseBtn = true
          this.chatbotClass = 'model-open'
          this.afterOpen()
        } else if (this.enableCloseBtnToDialog) {
          this.showCloseToDialog = true
        }
      }
    },
    async onUnloadEvent () {
      if (this.openChatWindow) {
        await this.chatbotOperationChatWindow({ companyId: this.rootCompanyId, open: false })
      }
    },
    onCloseDivClick () {
      this.showChatbot = false
      this.showCloseDiv = false
      this.showCloseToDialog = false
      this.chatbotClass = null
      this.beforeClose()
      document.querySelector('#main').style.overflow = null
      document.body.style.overflow = null
      this.chatbotOperationChatWindow({ companyId: this.rootCompanyId, open: false })
    },
    afterOpen: function () {
      this.scrollTop = document.scrollingElement.scrollTop
      document.body.classList.add(this.bodyClass)
      document.body.style.top = -this.scrollTop + 'px'
      document.scrollingElement.scrollTop = 0
    },
    beforeClose: function () {
      document.body.classList.remove(this.bodyClass)
      document.scrollingElement.scrollTop = this.scrollTop
    }
  },
  watch: {
    showCloseDiv () {
      if (this.showCloseDiv) {
        this.showCloseToDialog = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chatbot {
  .display-block, #chatbotNudge, #btnDialogClose {
    display: block;
  }

  #btnDialogClose {
    top: 4px;
    font-size: 24px;
  }

  .close-dialog-btn {
    bottom: 583px !important;
    right: 22px !important;
    height: 20px !important;
    top: auto !important;
    #btnDialogClose {
      position: absolute;
      top: auto;
      width: 20px;
      height: 20px;
      font-size: 20px;
    }
  }

  .chatbot-nudge {
    .close-btn-nudge {
      position: absolute;
      top: -4px;
      font-size: 14px;
      right: 0px;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: var(--custom-color);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px;
      .close-btn-icon {
        font-size: 10px;
        color: #fff;
      }
    }
  }
}
</style>
